import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PDFFormType } from '@models/matter-form-data';

export interface MatterFormViewerModalData {
	formId: PDFFormType;
	mortgageId?: string;
}

@Component({
	selector: 'app-matter-form-viewer-modal',
	templateUrl: './matter-form-viewer-modal.component.html',
	styleUrls: ['./matter-form-viewer-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterFormViewerModalComponent implements OnInit {
	public formId: PDFFormType;
	public mortgageId: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: MatterFormViewerModalData,
		private dialogRef: MatDialogRef<MatterFormViewerModalComponent>,
	) {}

	ngOnInit(): void {
		const { data } = this;
		if (data) {
			this.formId = data.formId;
			this.mortgageId = data.mortgageId;
		}
	}

	public _onClose() {
		this.dialogRef.close();
	}
}
